import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import Environment from 'Config/Environment';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: Environment.endpoint,
  timeout: 10000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  paramsSerializer: {
    indexes: null,
  },
});

// Interceptor para las respuestas
axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // Puedes transformar la respuesta aquí si es necesario
    return response;
  },
  (error: AxiosError) => {
    if (error.response) {
      // El servidor respondió con un código de estado fuera del rango 2xx
      switch (error.response.status) {
        case 401:
          localStorage.removeItem('token');
          window.location.href = '/';
          break;
        case 403:
          // Manejar error de autorización
          break;
        case 404:
          // Manejar error de recurso no encontrado
          break;
        case 500:
          // Manejar error del servidor
          break;
      }
    } else if (error.request) {
      // La petición fue hecha pero no se recibió respuesta
      console.error('No se recibió respuesta del servidor');
    } else {
      // Algo sucedió en la configuración de la petición
      console.error('Error en la configuración de la petición:', error.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
